export default defineAppConfig({
	ui: {
		dashboardSidebar: {
			slots: {
				root: "relative hidden lg:flex flex-col min-h-svh min-w-16 w-(--width) shrink-0 bg-primary",
				header: "h-(--ui-header-height) shrink-0 flex items-center gap-1.5 px-4",
				body: "flex flex-col gap-4 flex-1 overflow-y-auto px-4 py-2",
				footer: "shrink-0 flex items-center gap-1.5 px-4 py-2",
				toggle: "",
				handle: "",
				content: "lg:hidden",
				overlay: "lg:hidden"
			},
			variants: {
				menu: {
					true: {
						header: "sm:px-6",
						body: "sm:px-6",
						footer: "sm:px-6"
					}
				},
				side: {
					left: {
						root: "border-e border-default"
					},
					right: {
						root: ""
					}
				},
				toggleSide: {
					left: {
						toggle: ""
					},
					right: {
						toggle: "ms-auto"
					}
				}
			}
		},
		navigationMenu: {
			slots: {
				root: "relative flex gap-1.5 [&>div]:min-w-0",
				list: "isolate min-w-0 flex flex-col space-y-3",
				label: "w-full flex items-center gap-1.5 font-semibold text-xs/5 text-highlighted px-2.5 py-1.5",
				item: "min-w-0",
				link: "group relative w-full flex items-center gap-2 font-medium text-md before:absolute before:z-[-1] before:rounded-md focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-2",
				linkLeadingIcon: "shrink-0 size-5",
				linkLeadingAvatar: "shrink-0",
				linkLeadingAvatarSize: "2xs",
				linkLeadingChipSize: "sm",
				linkTrailing: "group ms-auto inline-flex gap-1.5 items-center",
				linkTrailingBadge: "shrink-0",
				linkTrailingBadgeSize: "sm",
				linkTrailingIcon: "size-5 transform shrink-0 group-data-[state=open]:rotate-180 transition-transform duration-200",
				linkLabel: "truncate",
				linkLabelExternalIcon: "inline-block size-3 align-top text-dimmed",
				childList: "isolate",
				childLabel: "text-xs text-highlighted",
				childItem: "",
				childLink:
					"group relative size-full flex items-start text-start text-sm before:absolute before:z-[-1] before:rounded-md focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-2",
				childLinkWrapper: "min-w-0",
				childLinkIcon: "size-5 shrink-0",
				childLinkLabel: "truncate",
				childLinkLabelExternalIcon: "inline-block size-3 align-top text-dimmed",
				childLinkDescription: "text-muted",
				separator: "px-2 h-px bg-border",
				viewportWrapper: "absolute top-full left-0 flex w-full",
				viewport:
					"relative overflow-hidden bg-default shadow-lg rounded-md ring ring-default h-(--reka-navigation-menu-viewport-height) w-full transition-[width,height,left] duration-200 origin-[top_center] data-[state=open]:animate-[scale-in_100ms_ease-out] data-[state=closed]:animate-[scale-out_100ms_ease-in] z-[1]",
				content: "",
				indicator:
					"absolute data-[state=visible]:animate-[fade-in_100ms_ease-out] data-[state=hidden]:animate-[fade-out_100ms_ease-in] data-[state=hidden]:opacity-0 bottom-0 z-[2] w-(--reka-navigation-menu-indicator-size) translate-x-(--reka-navigation-menu-indicator-position) flex h-2.5 items-end justify-center overflow-hidden transition-[translate,width] duration-200",
				arrow: "relative top-[50%] size-2.5 rotate-45 border border-default bg-default z-[1] rounded-xs"
			},
			variants: {
				active: {
					true: {
						childLink: "before:bg-elevated text-highlighted",
						childLinkIcon: "text-default"
					},
					false: {
						link: "text-white",
						linkLeadingIcon: "text-white",
						childLink: ["hover:before:bg-elevated/50 text-default hover:text-highlighted", "transition-colors before:transition-colors"],
						childLinkIcon: ["text-dimmed group-hover:text-default", "transition-colors"]
					}
				}
			},
			compoundVariants: [
				{
					orientation: "vertical",
					collapsed: false,
					class: {
						childList: "ms-5 border-s border-default",
						childItem: "ps-1.5 -ms-px",
						content:
							"data-[state=open]:animate-[collapsible-down_200ms_ease-out] data-[state=closed]:animate-[collapsible-up_200ms_ease-out] overflow-hidden"
					}
				},
				{
					orientation: "vertical",
					collapsed: true,
					class: {
						link: "px-1.5",
						linkLabel: "hidden",
						linkTrailing: "hidden",
						content: "shadow-sm rounded-sm min-h-6 p-1"
					}
				},
				{
					orientation: "horizontal",
					highlight: true,
					class: {
						link: ["after:absolute after:-bottom-2 after:inset-x-2.5 after:block after:h-px after:rounded-full", "after:transition-colors"]
					}
				},
				{
					orientation: "vertical",
					highlight: true,
					level: true,
					class: {
						link: ["after:absolute after:-start-1.5 after:inset-y-0.5 after:block after:w-px after:rounded-full", "after:transition-colors"]
					}
				},
				{
					disabled: false,
					active: false,
					variant: "pill",
					class: {
						link: ["hover:text-highlighted hover:before:bg-elevated/50", "transition-colors before:transition-colors"],
						linkLeadingIcon: ["group-hover:text-default", "transition-colors"]
					}
				},
				{
					disabled: false,
					active: false,
					variant: "pill",
					orientation: "horizontal",
					class: {
						link: "data-[state=open]:text-highlighted",
						linkLeadingIcon: "group-data-[state=open]:text-default"
					}
				},
				{
					disabled: false,
					variant: "pill",
					highlight: true,
					orientation: "horizontal",
					class: {
						link: "data-[state=open]:before:bg-elevated/50"
					}
				},
				{
					disabled: false,
					variant: "pill",
					highlight: false,
					active: false,
					orientation: "horizontal",
					class: {
						link: "data-[state=open]:before:bg-elevated/50"
					}
				},
				{
					color: "primary",
					variant: "pill",
					active: true,
					class: {
						link: "text-primary",
						linkLeadingIcon: "text-primary group-data-[state=open]:text-primary"
					}
				},
				{
					color: "neutral",
					variant: "pill",
					active: true,
					class: {
						link: "text-highlighted",
						linkLeadingIcon: "text-highlighted group-data-[state=open]:text-highlighted"
					}
				},
				{
					variant: "pill",
					active: true,
					highlight: false,
					class: {
						link: "before:bg-elevated"
					}
				},
				{
					variant: "pill",
					active: true,
					highlight: true,
					disabled: false,
					class: {
						link: ["hover:before:bg-elevated/50", "before:transition-colors"]
					}
				},
				{
					disabled: false,
					active: false,
					variant: "link",
					class: {
						link: ["hover:text-highlighted", "transition-colors"],
						linkLeadingIcon: ["group-hover:text-default", "transition-colors"]
					}
				},
				{
					disabled: false,
					active: false,
					variant: "link",
					orientation: "horizontal",
					class: {
						link: "data-[state=open]:text-highlighted",
						linkLeadingIcon: "group-data-[state=open]:text-default"
					}
				},
				{
					color: "primary",
					variant: "link",
					active: true,
					class: {
						link: "text-primary",
						linkLeadingIcon: "text-primary group-data-[state=open]:text-primary"
					}
				},
				{
					color: "neutral",
					variant: "link",
					active: true,
					class: {
						link: "text-highlighted",
						linkLeadingIcon: "text-highlighted group-data-[state=open]:text-highlighted"
					}
				},
				{
					highlightColor: "primary",
					highlight: true,
					level: true,
					active: true,
					class: {
						link: "after:bg-primary"
					}
				},
				{
					highlightColor: "neutral",
					highlight: true,
					level: true,
					active: true,
					class: {
						link: "after:bg-inverted"
					}
				}
			],
			defaultVariants: {
				color: "primary",
				highlightColor: "primary",
				variant: "pill"
			}
		},
		formField: {
			slots: {
				root: "",
				wrapper: "",
				labelWrapper: "flex content-center items-center justify-between gap-1",
				label: "block text-sm font-semibold text-slate-700 mb-2 uppercase tracking-wider",
				container: "relative",
				description: "text-muted",
				error: "mt-2 text-error",
				hint: "text-muted",
				help: "mt-2 text-muted"
			},
			variants: {
				size: {
					xs: {
						root: "text-xs"
					},
					sm: {
						root: "text-xs"
					},
					md: {
						root: "text-sm"
					},
					lg: {
						root: "text-sm"
					},
					xl: {
						root: "text-base"
					}
				},
				required: {
					true: {
						label: "after:content-['*'] after:ms-0.5 after:text-error"
					}
				},
				orientation: {
					vertical: {
						container: "mt-1"
					},
					horizontal: {
						root: "flex justify-between place-items-baseline gap-2"
					}
				}
			},
			defaultVariants: {
				size: "md",
				orientation: "vertical"
			}
		}
	}
})
